//设置cookie
function SetCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  // console.info(cname + "=" + cvalue + "; " + expires);
  document.cookie = cname + "=" + cvalue + "; " + expires;
  // console.info(document.cookie);
}


//获取cookie
function GetCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) != -1) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

//清除cookie
function ClearCookie(cname) {
  SetCookie(cname, "", -1);
}



function SetUserInfo(obj) {
  this.userInfo = obj;
}


function SetNewUserInfo(obj) {
  this.userInfo1 = obj;
}

module.exports = {
  SetCookie,
  GetCookie,
  ClearCookie,
  // userInfo: {
  //   userId: '',
  //   name: '',
  //   tel: '',
  //   IDNumber: '',
  //   joinTime: '',
  //   timeStamp: '',
  //   token: '',
  // },
  userInfo:null,
  SetUserInfo,

  userInfo1:null,
  SetNewUserInfo,
};



// WEBPACK FOOTER //
// ./src/js/common.js